import { FaArrowRight} from "react-icons/fa";
import Navbar from "../Navbar";
import '../landing.css';
import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaAnchor} from "react-icons/fa6";
import Gen from '../assets/robot.jpg';
import Data from '../assets/data-agent.jpg'
import Conversation from '../assets/coversation-agent.jpg'
import Automation from '../assets/automation.jpg'
import Vision from '../assets/ai_third.jpg'
import Reason from '../assets/headphone.jpg'
const Header= () => {
 const [activeIndex, setActiveIndex] = useState(0);
const imageData = [
  {
    word: 'Gen AI',
    image: Gen,
    title: 'Intelligent AI Agents \nfor Every Operation',
    description: 'Transform your business with cutting-edge AI technology. Create intelligent solutions that drive innovation and growth.',
    link: '/gen-ai'
  },
  {
   word: 'Vision Agent',
    image: Vision,
    title: 'See Beyond the Visible.',
    description: ' Sees and understands the physical world. Detects, tracks, and analyzes visuals in real time — from industrial inspections to safety compliance.',
    link: '/blockchain'
  },
  {
  word: 'Data Agent',
    image: Data,
    title: 'From Raw Data to Real Insight',
    description: 'Turns raw data into actionable intelligence. Collects, processes, and predicts outcomes to help you make faster, smarter business decisions.',
    link: '/blockchain'
  },
  {
   word: 'Conversational Agent',
    image: Conversation,
    title: 'Talk to Technology, Naturally.',
    description: ' Engages with users through intelligent conversation. Understands intent, emotion, and context — delivering human-like interaction for support, training, or engagement.',
    link: '/cybersecurity'
  },
  {
    word: 'Automation Agent',
    image: Automation,
    title: 'Let Intelligence Handle the Routine.',
    description: 'Executes complex workflows autonomously. Integrates seamlessly across your digital tools and systems to perform repetitive or time-sensitive tasks with precision.',
    link: '/cloud'
  },
  {
 word: 'Reasoning Agent',
    image: Reason,
    title: 'Think. Decide. Adapt.',
    description: 'Applies logic and contextual intelligence to evaluate data, understand dependencies, and make informed decisions — evolving continuously through learning.',
    link: '/cloud'
  }
];
  return (
  <>
<Navbar />
 <div
  style={{
    height: "100vh",
    width: "100vw",
    overflow: "hidden",
    position: "relative",
    margin: 0,
    padding: 0,
  }}
>
  {/* Background Image */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${imageData[activeIndex].image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      transition: "background-image 0.5s ease-in-out",
      zIndex: 1,
    }}
  >
    {/* Overlay */}
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        zIndex: 2,
      }}
    />
  </div>

  {/* Content Row (Words + Main Content) */}
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "2%",
      transform: "translateY(-50%)",
      zIndex: 3,
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      gap: "80px",
      maxWidth: "90%",
    }}
  >
    {/* Words Navigation (Left Column) */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        minWidth: "200px",
      }}
    >
      {imageData.map((item, index) => (
        <h6
          key={index}
          onMouseEnter={() => setActiveIndex(index)}
          style={{
            color:
              activeIndex === index
                ? "#61c4f2ff"
                : "#fff",
            fontSize: "1.6rem",
            fontWeight: "700",
            cursor: "pointer",
            margin: 0,
            transition: "all 0.3s ease",
            // textShadow: "2px 2px 8px rgba(233, 228, 228, 0.8)",
            userSelect: "none",
            letterSpacing: "2px",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          }}
          className="hover-forward"
        >
          <FaAnchor /> {item.word} <FaArrowRight />
        </h6>
      ))}
    </div>

    {/* Main Content (Right Column) */}
    <div style={{ maxWidth: "600px" }}>
      <h1
        style={{
          color: "#fff",
          fontSize: "3.5rem",
          fontWeight: "700",
          lineHeight: "1.2",
          marginBottom: "20px",
          textShadow: "2px 2px 8px rgba(0, 0, 0, 0.8)",
          whiteSpace: "pre-line",
        }}
      >
        {imageData[activeIndex].title}
      </h1>
      <p
        style={{
          color: "#fff",
          fontSize: "1.2rem",
          lineHeight: "1.6",
          marginBottom: "30px",
          textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
        }}
      >
        {imageData[activeIndex].description}
      </p>
      {/* <button
        style={{
          backgroundColor: "rgba(106, 29, 194, 0.9)",
          color: "#fff",
          border: "none",
          padding: "15px 35px",
          fontSize: "1.1rem",
          fontWeight: "600",
          borderRadius: "10px",
          cursor: "pointer",
          transition: "all 0.3s ease",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = "#61c4f2ff";
          e.target.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = "#35b8f5ff";
          e.target.style.transform = "translateY(0)";
        }}
        onClick={() => (window.location.href = imageData[activeIndex].link)}
      >
        Explore More
      </button> */}
    </div>
  </div>

  {/* Current Selection Indicator */}
  <div
    style={{
      position: "absolute",
      bottom: "30px",
      right: "30px",
      zIndex: 3,
      color: "#fff",
      fontSize: "1rem",
      fontWeight: "500",
      textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      padding: "10px 20px",
      borderRadius: "20px",
    }}
  >
    {activeIndex + 1} / {imageData.length}
  </div>
</div>
  </>
  );
};

export default Header;
